import { getCalendarDatePartsInTimezone } from '@foodfluence/shared';

/** Returns the browser's IANA timezone (e.g. "America/Los_Angeles"). */
export const getBrowserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

const isValidTimezone = (timezone?: string | null): timezone is string => {
  if (!timezone) return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: timezone });
    return true;
  } catch {
    return false;
  }
};

/**
 * The collab's due-date timezone, in the backend's resolveDueDateTimezone order: pass the store
 * location's, the creator's stored one and the campaign's first location's, in that order. The
 * first valid one wins; none means UTC, as on the server.
 */
export const resolveDueDateTimezone = (...candidates: (string | null | undefined)[]): string =>
  candidates.find(isValidTimezone) ?? 'UTC';

/** Local midnight of `date`'s calendar day in `timezone` — the day a date picker should show. */
export const calendarDayInTimezone = (date: Date, timezone: string): Date => {
  const { year, month, day } = getCalendarDatePartsInTimezone(date, timezone);
  return new Date(year, month - 1, day);
};
